export const routePathsOrderPickup = {
  ORDER_PICKUP: '/pickups',
  CONFIRMATION: '/pickups/confirmation',
  CONFIRMATION_ID: '/pickups/confirmation/:confirmationId',
  LI_ION_BATTERIES: '/pickups/li-ion-batteries',
  LI_ION_BATTERIES_REQUEST_PICKUP: '/pickups/li-ion-batteries/request-pickup',
  LI_ION_BATTERIES_CONFIRMATION: '/pickups/li-ion-batteries/confirmation/:confirmationId',
  PREVIOUS_ORDERS: '/pickups/previous-orders/',
  PICKUP_SCHEDULE: '/pickups/pickup-schedule',
  DECLARATION: '/pickups/declaration',
  RENTED_CONTAINERS: '/pickups/rented-containers',
  SORTING_GUIDANCE: '/pickups/sorting-guidance',
  RENTED_CONTAINERS_ADD_CONTAINERS: '/pickups/rented-containers/add-containers',
  RENTED_CONTAINERS_ADD_CONTAINERS_CONFIRMATION:
    '/pickups/rented-containers/add-containers/confirmation/:transactionId',
  REQUEST_NEW_PROJECT: '/pickups/request-new-project',
  REQUEST_NEW_PROJECT_CHECKOUT: '/pickups/request-new-project/checkout',
} as const;
